module.exports = __webpack_public_path__ + "img/Flag_of_the_Faroe_Islands.6d87f7e6.svg";